import { render, staticRenderFns } from "./ProductDetailAccordionEdit.vue?vue&type=template&id=960349e2&"
import script from "./ProductDetailAccordionEdit.vue?vue&type=script&lang=js&"
export * from "./ProductDetailAccordionEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports